module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "Helpful Hints"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e28",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Helpful Hints ")])])])])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e28",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("1. Small boxes of sugar-free instant pudding can be used in place of the small boxes of\n        regular instant pudding in most recipes. Low-fat or non-fat ingredients can be used in most\n        recipes as well. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e28",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("2. Vanilla, white chocolate, or cheesecake pudding mixes can be used interchangeably in\n        most recipes. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e28",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("3. Store recipe leftovers in the refrigerator. Most of the recipes in this book contain\n        milk-based products and should be stored at a cold temperature before and after being\n        served. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e28",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("4. For best results, thaw frozen whipped topping in the refrigerator a day before you plan\n        to use it. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e28",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("5. For cakes, always grease and flour the cake pan, or spray it with nonstick cooking\n        spray even when the cake recipe doesn’t call for it. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e28",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("6. Bake cakes and cookies on the middle oven rack, never on the top or bottom racks. To\n        see if a cake is done, insert a toothpick into the center—if it comes out clean\n        it’s done. Or, if the cake springs back when touched, it’s usually done. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e28",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("7. For best results, use glass or stoneware baking dishes. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e28",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("8. The first time you try a recipe, check for doneness 5 minutes before its minimum\n        cooking time ends. Every oven heats differently. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e28",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("9. For chewier and softer cookies and bars, take them out of the oven just as they begin\n        to look golden and let them cool on or in the pan. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e28",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("10. For recipes using gelatin, make sure the gelatin is completely dissolved in hot water\n        before adding any cold water. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e28",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("11. When using fresh fruit, dip it in pineapple, orange, or lemon juice to prevent it from\n        changing color.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee45c18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch01.vue
// module id = 72
// module chunks = 0